import { MedicalReimbursement } from '../../database/tables'
import medicalReimbursementServiceConfigs from './configs'

export default function getFileNameFromRef(fileRef: MedicalReimbursement['supportingDocumentRef']): string {
  if (!!fileRef) {
    return fileRef.replace(medicalReimbursementServiceConfigs.collectionName, '')
  }
  return ''
}
